import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _MessageBox2 from "element-ui/lib/theme-chalk/message-box.css";
import "element-ui/lib/theme-chalk/base.css";
import _MessageBox from "element-ui/lib/message-box";
import _Popover2 from "element-ui/lib/theme-chalk/popover.css";
import "element-ui/lib/theme-chalk/base.css";
import _Popover from "element-ui/lib/popover";
import _Dialog2 from "element-ui/lib/theme-chalk/dialog.css";
import "element-ui/lib/theme-chalk/base.css";
import _Dialog from "element-ui/lib/dialog";
import _Image2 from "element-ui/lib/theme-chalk/image.css";
import "element-ui/lib/theme-chalk/base.css";
import _Image from "element-ui/lib/image";
import _Checkbox2 from "element-ui/lib/theme-chalk/checkbox.css";
import "element-ui/lib/theme-chalk/base.css";
import _Checkbox from "element-ui/lib/checkbox";
import _Option2 from "element-ui/lib/theme-chalk/option.css";
import "element-ui/lib/theme-chalk/base.css";
import _Option from "element-ui/lib/option";
import _Select2 from "element-ui/lib/theme-chalk/select.css";
import "element-ui/lib/theme-chalk/base.css";
import _Select from "element-ui/lib/select";
import _Button2 from "element-ui/lib/theme-chalk/button.css";
import "element-ui/lib/theme-chalk/base.css";
import _Button from "element-ui/lib/button";
import _Input2 from "element-ui/lib/theme-chalk/input.css";
import "element-ui/lib/theme-chalk/base.css";
import _Input from "element-ui/lib/input";
import _TableColumn2 from "element-ui/lib/theme-chalk/table-column.css";
import "element-ui/lib/theme-chalk/base.css";
import _TableColumn from "element-ui/lib/table-column";
import _Table2 from "element-ui/lib/theme-chalk/table.css";
import "element-ui/lib/theme-chalk/base.css";
import _Table from "element-ui/lib/table";
import _FormItem2 from "element-ui/lib/theme-chalk/form-item.css";
import "element-ui/lib/theme-chalk/base.css";
import _FormItem from "element-ui/lib/form-item";
import _Form2 from "element-ui/lib/theme-chalk/form.css";
import "element-ui/lib/theme-chalk/base.css";
import _Form from "element-ui/lib/form";
import _Icon2 from "element-ui/lib/theme-chalk/icon.css";
import "element-ui/lib/theme-chalk/base.css";
import _Icon from "element-ui/lib/icon";
import "/data/jenkins/workspaces/workspace/h5/node_modules/core-js/modules/es.array.iterator.js";
import "/data/jenkins/workspaces/workspace/h5/node_modules/core-js/modules/es.promise.js";
import "/data/jenkins/workspaces/workspace/h5/node_modules/core-js/modules/es.object.assign.js";
import "/data/jenkins/workspaces/workspace/h5/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import 'element-ui/lib/theme-chalk/index.css';
import api from './api/api';
import request from './api/request';
import './assets/css/base.css';
import './assets/css/resetDefault.scss';
import './assets/icons';
import './assets/icons/iconfont.css';
import utils from './utils/utils';
Vue.use(_Icon);
Vue.use(_Form);
Vue.use(_FormItem);
Vue.use(_Table);
Vue.use(_TableColumn);
Vue.use(_Input);
Vue.use(_Button);
Vue.use(_Select);
Vue.use(_Option);
Vue.use(_Checkbox);
Vue.use(_Image);
Vue.use(_Dialog);
Vue.use(_Popover);
Vue.prototype.$msgbox = _MessageBox;
Vue.prototype.$confirm = _MessageBox.confirm;
Vue.prototype.$alert = _MessageBox.alert;
Vue.prototype.$message = _Message;
Vue.prototype.$request = request;
Vue.prototype.$api = api;
Vue.prototype.$utils = utils;
Vue.config.productionTip = false; // npm监控平台

import '@/lib/apm.js';
import '@/lib/zhuge.js';
window.globalVue = new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');